import React from "react";
import { Text, View } from "@react-pdf/renderer";
import ArabicComponent from "../../../../../../utils/ArabComponent/ArabicComponent";
import MonthlyCharges from "./MonthlyCharges";
import { TABLE_TWO_ARABIC_DATA, TABLE_TWO_DATA } from "./Data";

const Page1 = ({ styles, contractDetails, generatedTitles }) => {
  const { client, visa_provider } = contractDetails;

  return (
    <>
      <Text
        style={{
          textAlign: "center",
          marginTop: 3,
          fontSize: 12,
          fontFamily: "Helvetica-Bold",
        }}
      >
        ANNEXURE – I
      </Text>
      <Text style={{ textAlign: "center", fontSize: 9 }}>
        (Commercial and other terms accepted and signed by both parties)
      </Text>

      <View style={{ marginTop: 20, fontSize: 9 }}>
        <View style={{ flexDirection: "col" }}>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text style={{ fontFamily: "Helvetica-Bold", width: "50%" }}>
              {" "}
              First Party:
            </Text>

            <ArabicComponent
              arabText={"الطرف الأول:"}
              textStyle={{ fontFamily: "ArabicBold" }}
              componentStyle={{ width: "50%" }}
            />
          </View>
          <View style={{ gap: 2, width: "100%" }}>
            {/* VISA PROVIDER */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.visa_provider?.name}
              </Text>
              <Text style={{ textAlign: "right" }}>
                <ArabicComponent
                  arabText={contractDetails?.visa_provider?.name_arabic}
                  componentStyle={{ width: "50%" }}
                />
              </Text>
            </View>
            {/* CR NUMBER */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.visa_provider?.company_registration}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.visa_provider?.company_registration}
              </Text>
            </View>

            {/* ADDRESS */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.visa_provider?.address}
              </Text>
              <Text style={{ textAlign: "right" }}>
                <ArabicComponent
                  arabText={contractDetails?.visa_provider?.address_arabic}
                  componentStyle={{ width: "50%" }}
                />
              </Text>
            </View>

            {/* PO BOX */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.visa_provider?.po_box}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.visa_provider?.po_box}
              </Text>
            </View>

            {/* PIN CODE */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.visa_provider?.pincode}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.visa_provider?.pincode}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ flexDirection: "col", marginTop: 20 }}>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text style={{ fontFamily: "Helvetica-Bold", width: "50%" }}>
              {" "}
              Second Party:{" "}
            </Text>

            <ArabicComponent
              arabText={"الطرف الثاني:"}
              textStyle={{ fontFamily: "ArabicBold" }}
              componentStyle={{ width: "50%" }}
            />
          </View>
          <View style={{ gap: 2, width: "100%" }}>
            {/* CLIENT NAME */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.client?.name}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.client?.name}
              </Text>
            </View>
            {/* CR NUMBER */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.client?.company_registration}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.client?.company_registration}
              </Text>
            </View>

            {/* ADDRESS */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.client?.address}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.client?.address}
              </Text>
            </View>

            {/* PO BOX */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.client?.po_box}
              </Text>
              <Text style={{ width: "50%", textAlign: "right" }}>
                {contractDetails?.client?.po_box}
              </Text>
            </View>

            {/* PIN CODE */}
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Text style={{ width: "50%" }}>
                {contractDetails?.client?.pincode}
              </Text>
              <Text style={{ textAlign: "right" }}>
                <ArabicComponent
                  arabText={contractDetails?.client?.pincode}
                  componentStyle={{ width: "50%" }}
                />
              </Text>
            </View>
          </View>
        </View>
      </View>

      <MonthlyCharges
        generatedTitles={generatedTitles}
        contractDetails={contractDetails}
      />

      {/* note */}
      <Text style={{ fontSize: 12, marginVertical: 20 }}>
        All of the above charges are excluding 15% VAT. 15% VAT will be
        applicable and added to all invoices, Governmental and Non-Governmental
      </Text>
      {/* Table 2 */}
      <View style={{ flexDirection: "row", border: 1 }}>
        {/* col 1 */}
        <View style={{ borderRight: 1, width: "100%", padding: 5 }}>
          {TABLE_TWO_DATA?.map((item, index) => (
            <View style={{ marginVertical: 10 }} key={index}>
              <Text break style={{ lineHeight: 1.5, fontSize: 9 }}>
                {item?.text}
              </Text>
            </View>
          ))}
        </View>
        {/* col 2 */}
        <View style={{ width: "100%", padding: 5 }}>
          {TABLE_TWO_ARABIC_DATA?.map((item, index) => (
            <View style={{ marginVertical: 10 }} key={index}>
              <ArabicComponent arabText={item?.text} />
            </View>
          ))}
        </View>
      </View>
    </>
  );
};

export default Page1;
